import * as DamHistory from '../../../../services/damHistory.service';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import t from './DamHistory.type';

export const fetchDamHistoryList = (params) => async (dispatch) => {
  try {
    const res = await DamHistory.fetchDamHistoryList(params);
    if (res && res.code === 200) {
      await dispatch({
        type: t.GET_DAM_HISTORY_LIST,
        payload: {
          data: res.data.documents,
          totalRecords: res.data.totalRecords,
          searchText: params.searchText,
          isScrolled: params.isScrolled,
        },
      });
      return true;
    }
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_DAM_REDUCER,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
